import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: PortionUpdateInput!
  ) {
    updateOnePortion(
      where: { id: $id }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Mapa actualizado`, mutationTypes.UPDATE)
)

